export enum DrawerStatusEnum {
  View = "VIEW",
  Edit = "EDIT",
}

export enum TabPaneStatusEnum {
  Info = "1",
  Items = "2",
}
